import React, {useState} from 'react';

const noLogoPlaceholder = 'static/images/no-logo.png';
const commonClass = 'rounded-full object-cover';

function getInitials(identity, type) {
    let words = [];
    if (type === 'project') {
        words = identity?.name?.trim().split(/\s+/).filter(Boolean) ?? [];
    } else {
        words = [identity?.firstName, identity?.lastName].filter(value => typeof value === 'string' && value.trim());
    }

    const initials = words.slice(0, 2).map(word => word.trim().charAt(0).toUpperCase()).join('');
    return initials || '?';
}

function IdentityImagePart({url, config, className, identity, type}) {
    const [failedUrl, setFailedUrl] = useState(null);
    const hasNoUsableUrl = typeof url !== 'string'
        || url.trim() === ''
        || url.includes(noLogoPlaceholder);
    const imageFailed = failedUrl === url;
    const identityName = type === 'project'
        ? identity?.name
        : [identity?.firstName, identity?.lastName].filter(Boolean).join(' ');
    const placeholderClass = type === 'user' ? 'box-shadow-none' : '';
    const classes = [config.class, commonClass, className];

    if (hasNoUsableUrl || imageFailed) {
        return (
            <div
                className={[...classes, 'avatar-placeholder bg-slate-900 flex items-center justify-center font-semibold text-white', placeholderClass].join(' ')}
                role="img"
                aria-label={identityName || (type === 'project' ? 'Project' : 'User')}
            >
                {getInitials(identity, type)}
            </div>
        );
    }

    return (
        <img
            className={classes.join(' ')}
            src={url}
            width={config.width}
            height={config.height}
            alt={identityName || (type === 'project' ? 'Project' : 'User')}
            onError={() => setFailedUrl(url)}
        />
    );
}

export default function IdentityImage({url, url2, className, large = false, medium = false, project = null, user = null}) {
    const largeConfig = {
        class: 'avatar-big block min-w-20 min-h-20 w-20 h-20 text-lg',
        width: 80,
        height: 80,
    };
    const smallConfig = {
        class: 'avatar-small block min-w-8 min-h-8 w-8 h-8 text-xs',
        width: 32,
        height: 32,
    };
    const mediumConfig = {
        class: 'avatar-medium block min-w-10 min-h-10 w-10 h-10 text-sm',
        width: 40,
        height: 40,
    };
    const config = large ? largeConfig : medium ? mediumConfig : smallConfig;
    const renderImage = (imageUrl, type, identity) => (
        <IdentityImagePart
            url={imageUrl}
            config={config}
            className={className}
            identity={identity}
            type={type}
        />
    );

    if (large || medium) {
        const type = project && !user ? 'project' : 'user';
        const identity = type === 'project' ? project : user;
        return (
            <div className="rounded-full bg-gray-200">
                {renderImage(url, type, identity)}
            </div>
        );
    }

    if (user && project) {
        return (
            <ul className="flex flex-wrap justify-center sm:justify-start">
                <li>{renderImage(url, 'user', user)}</li>
                <li className="-ml-2">{renderImage(url2 ?? project.logoUrl, 'project', project)}</li>
            </ul>
        );
    }

    const type = project ? 'project' : 'user';
    const identity = project ?? user;
    return (
        <ul className="flex flex-wrap justify-center sm:justify-start">
            <li>{renderImage(url, type, identity)}</li>
        </ul>
    );
}
